import React from 'react';
import LottieAnimation from '@/components/behaviours/LottieAnimation';
import Icon from '@/components/atoms/Icon';
import animationData from './LottieDesktopExpand.json';

const DesktopExpand = (props) => (
    <Icon iconName="DesktopExpand" {...props}>
        <LottieAnimation loop autoplay animationData={animationData} />
    </Icon>
);

export default DesktopExpand;
